import React from 'react'
import RdnaText from '@ringdna/common/src/components/RdnaText'

type Props = {
  label: string
  value: string
}

export default function Detail({ label, value }: Props) {
  return (
    <span>
      <RdnaText bold={true}>{label}:</RdnaText> <RdnaText>{value}</RdnaText>
    </span>
  )
}
